import { gql } from '@apollo/client'

export const reorderStory = gql`
  mutation ReorderStory($records: [StoryIndexChangeInput!]!) {
    reorderStory(stories: $records)
  }
`
